import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { NavigationOptions } from './models/navigation-options';
import { NgTemplateOutlet } from '@angular/common';
import { ButtonMenuComponent } from '../button-menu/button-menu.component';

@Component({
    selector: 'app-page-header-nav',
    imports: [
        MatButtonModule,
        RouterModule,
        ButtonMenuComponent,
        NgTemplateOutlet,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './page-header-nav.component.html',
})
export class PageHeaderNavComponent {
    @Input() title: string = '';
    @Input() navItems: NavigationOptions = {
        primaries: [],
        secondaries: [],
        tertiaries: [],
        quaternaries: [],
    };
}
